// Order dentro de la matriz en nivel de prioridad
export const NOMINATIVE_ATRIBUTE = ["name", "denominacion", "nombre"];
